import { Link } from "react-router-dom";

export default function JoinSection() {
  return (
    <section id="cadastro" className="w-full bg-beige py-16 md:py-24 relative overflow-hidden">
      {/* Colonial decorative element */}
      <div className="absolute top-0 right-0 w-32 h-32 border-l border-b border-primary/10 rounded-bl-3xl hidden md:block" />
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-3xl mx-auto text-center relative z-10">
        <p className="font-body text-xs tracking-[0.25em] uppercase text-primary mb-3">
          Junte-se a Nós
        </p>
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl text-brown mb-4">
          Faça parte da comunidade
        </h2>
        <p className="font-body text-brown/70 text-base leading-relaxed max-w-xl mx-auto mb-8">
          Preencha seu cadastro para fazer parte da nossa rede de apoio.
          Será um prazer te conhecer e caminharmos juntas.
        </p>
        <Link
          to="/cadastro"
          className="inline-block font-body text-sm md:text-base px-10 py-4 rounded-full bg-primary text-white tracking-wide uppercase transition-all duration-300 hover:bg-primary-dark hover:scale-[1.02] whitespace-nowrap"
        >
          Quero fazer parte da comunidade
        </Link>
      </div>
    </section>
  );
}